var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_vm._v(" 404 - Error Page ")])}
var staticRenderFns = []

export { render, staticRenderFns }